import { ControlValueAccessor,} from '@angular/forms';
import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * This component was partially copied from klippa-app/ngx-enhancy-forms which holds the MIT license.
 * 
 * This component is a base in order to create a component that supports ngModel.
 * Some important things to know about it:
 *
 * innerValue = your own inner state, which you should use to store the current state of what ngModel should be.
 * writeValue() = called by angular, when ngModel is changed from OUTSIDE of the component. Feel free to patch this method if you need inner logic to happen when ngModel is altered from the outside. Always remember to also call the super.writeValue if you do!
 * setInnerValueAndNotify() = call this when you want your ngModel to be updated from INSIDE of your component, and provide it to the OUTSIDE.
 * ngOnInit() = Used to support the angular reactive forms framework. If you use ngOnInit in your own component (which happens fairly often) you must not forget to call the super.ngOnInit() method.
 */

@Component({
    selector: '',
    template: '',
    standalone: false
})
export class ValueAccessorBase<T> implements ControlValueAccessor {
	public innerValue?: T = undefined;
	public changed = new Array<(value: T | undefined) => void>();
	private touched = new Array<() => void>();

	@Input() public disabled = false;
	@Output() public onTouch = new EventEmitter<void>();

	touch(): void {
		this.touched.forEach((f) => f());
	}

	writeValue(value: T): void {
		this.innerValue = value;
	}

	registerOnChange(fn: (value: T | undefined) => void): void {
		this.changed.push(fn);
	}

	registerOnTouched(fn: () => void): void {
		this.touched.push(fn);
	}

	setInnerValueAndNotify(value: T | undefined): void {
        this.innerValue = value;
        this.changed.forEach((fn) => fn(value));
	}

	resetToNull(): void {
		this.setInnerValueAndNotify(undefined);
	}
}